var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Mapmarker-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map/Location-pins/default",
    transform: "translate(-2.000000, -3.000000)",
    fill: "#FFFFFF",
    stroke: "#72777F",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Mapmarker-filled",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,1 C11.861283,1 8.11588199,2.73243172 5.40418121,5.52887314 C2.68151449,8.3366232 1,12.2161759 1,16.5 C1,21.8132483 2.56643317,23.9594032 9.60163999,34.294958 C11.1782901,36.6112443 13.0256183,39.3252018 15.1868617,42.5562741 C15.3826236,42.8479106 15.6895619,43 16.0000027,43 C16.3104373,43 16.6173699,42.8479109 16.814051,42.5549121 C18.9743817,39.3252018 20.8217099,36.6112443 22.39836,34.294958 C29.4335668,23.9594032 31,21.8132483 31,16.5 C31,12.2161759 29.3184855,8.3366232 26.5958188,5.52887314 C23.884118,2.73243172 20.138717,1 16,1 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveMapMarker);
export default __webpack_public_path__ + "static/media/inactive-map-marker.93f5d3fae675e53b786579a8bf8666fa.svg";
export { ForwardRef as ReactComponent };